export function abbreviateAddress(address: string, n = 4) {
  const prefix = address.substring(0, 2)
  const first = address.substring(2, n + 2)
  const last = address.slice(-n)
  return prefix + first + '...' + last
}
